import { render, staticRenderFns } from "./SpeedTestPage.vue?vue&type=template&id=ab666bee&scoped=true"
import script from "./SpeedTestPage.vue?vue&type=script&lang=js"
export * from "./SpeedTestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab666bee",
  null
  
)

export default component.exports